import {
  Component,
  ContentChild,
  EventEmitter,
  Input,
  NgZone,
  Output,
  ViewChild,
} from '@angular/core';
import * as debug from 'debug';
import { Slides } from 'ionic-angular';
import * as _ from 'lodash';
import * as $ from 'jquery';
import { Content } from 'ionic-angular';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { ToolsProvider } from '../../providers/tools/tools';

// SubnavAndSlidesComponent
//
// This gets pretty tricky with scrolling.
// The way we will solve
@Component({
  selector: 'subnav-and-slides',
  templateUrl: 'subnav-and-slides.html',
})
export class SubnavAndSlidesComponent {
  debug = debug('debug:app:SubnavAndSlidesComponent');
  log = debug('app:SubnavAndSlidesComponent');

  @Input() tabs = [];
  @Input() navName = '';
  @Output() refresh = new EventEmitter();
  @Output() tabChange = new EventEmitter();
  @ViewChild(Slides) slides: Slides;
  @ViewChild('header') header;
  @ViewChild('container') container;
  @ViewChild('nav') nav;
  @ContentChild('slides') slidesTemplate;

  heightData = {
    headerHeight: 0,
    containerHeight: 0,
    containerScrollHeight: 0,
    navHeight: 35.5,
    slideScrollHeight: 0,
    slideScrollHeightInitial: 0,
    slideScrollHeightStyle: this.sanitization.bypassSecurityTrustStyle(''),
  };
  touchMoveData: any = null;
  isSticky = false;
  subs = [];
  tabIndex = 0;
  refresherSettings = {
    threshold: 75,
    max: 75,
    min: 20,
  };
  activeRefresher;

  constructor(
    public sanitization: DomSanitizer,
    private content: Content,
    private zone: NgZone,
    public tools: ToolsProvider
  ) {
    this.subs.push(
      this.tools.on('resize', () => {
        try {
          this.slides.update();
          this.update();
        } catch (e) {}
      }),
      this.tools.on('onKeyboardDidShow', () => {
        try {
          this.slides.update();
          this.update();
        } catch (e) {}
      }),
      this.tools.on('onKeyboardDidHide', () => {
        try {
          this.slides.update();
          this.update();
        } catch (e) {}
      }),
      this.tools.on('viewDidEnter', () => {
        try {
          this.slides.update();
          this.update();
        } catch (e) {}
      })
    );
    window['_subnavAndSlides'] = this;
  }

  ngOnInit() {
    this.hijackContentScroll();
    this.update();
    this.containerScrollWatch();
  }

  ngOnChanges() {
    this.update();
  }

  private update() {
    if (this.tabs && this.tabs[0]) {
      this.tabs[0].dirty = true;
    }

    setTimeout(() => {
      const containerHeight = $(this.container.nativeElement)
        .parents('.scroll-content')
        .height();

      // must not be an active page or something
      if (!containerHeight) return this.debug('no container height');

      this.log('init', this.tabs);
      this.slides.lockSwipes(true);
      this.slides.update();
      this.tools.logAnalyticsEvent(
        'trackCustom',
        (this.navName ? this.navName + '-' : '') +
          'tab-' +
          _.get(_.first(this.tabs), 'id')
      );

      this.heightData.headerHeight = this.header.nativeElement.clientHeight;
      this.heightData.containerHeight = $(this.container.nativeElement)
        .parents('.scroll-content')
        .height();
      this.heightData.containerScrollHeight =
        this.heightData.containerHeight + this.heightData.headerHeight;
      this.heightData.navHeight = this.nav.nativeElement.clientHeight;
      this.heightData.slideScrollHeight =
        this.heightData.containerHeight - this.heightData.navHeight;
      this.heightData.slideScrollHeightStyle = this.sanitization.bypassSecurityTrustStyle(
        `--scroll-height: ${this.heightData.slideScrollHeight}px;
        height: ${this.heightData.containerScrollHeight}px;
        `
      );

      this.log('height data', this.heightData);

      // block scrolling if no header
      if (this.heightData.headerHeight) {
        $(this.container.nativeElement)
          .parents('.scroll-content')
          .css({ overflowY: 'scroll' });
      } else {
        $(this.container.nativeElement)
          .parents('.scroll-content')
          .css({ overflowY: 'hidden' });
      }

      this.setIsSticky();
    });
  }

  changeActiveTabIndex(tab) {
    tab.dirty = true;
    const tabIndex = _.findIndex(this.tabs, st => {
      return st.id == tab.id;
    });
    this.log('change tab to', tab, tabIndex, this.slides);
    this.slides.lockSwipes(false);
    this.slides.slideTo(tabIndex);
    this.slides.lockSwipes(true);
    this.tabIndex = tabIndex;
    this.tools.logAnalyticsEvent('trackCustom', 'news-tab-' + tab.id);
    this.tabChange.emit(tab);
  }

  private containerScrollWatch() {
    this.subs.push(
      this.content.ionScroll.subscribe(
        _.throttle(() => {
          this.setIsSticky();
        }, 20)
      )
    );
  }

  private setIsSticky() {
    this.isSticky = true;

    // Note - This was causing problems on some versions of Android when there
    // was a seperate scrollable header. Leaving this in place for future reference
    // due to the amount of time spent tryin to solve the issue

    // this.zone.run(() => {
    //   const dims = this.content.getContentDimensions(),
    //     scrollTop = dims.scrollTop || 0,
    //     { scrollHeight, contentHeight } = dims,
    //     maxScroll = scrollHeight - contentHeight;

    //   if (
    //     scrollTop >= this.heightData.headerHeight ||
    //     !this.heightData.headerHeight ||
    //     (maxScroll && scrollTop >= maxScroll - 1)
    //   ) {
    //     this.isSticky = true;
    //   } else {
    //     this.isSticky = false;
    //   }
    //   this.debug('scroll dims', dims);
    //   this.debug(
    //     'scroll | isSticky(%s), scrollTop(%s), headerHeight(%s), scrollHeight(%s), maxScroll(%s)',
    //     this.isSticky,
    //     scrollTop,
    //     this.heightData.headerHeight,
    //     scrollHeight,
    //     maxScroll
    //   );
    // });
  }

  private activeScrollDiv() {
    const els = this.container.nativeElement.querySelectorAll(
      '.ScrollableContent'
    );
    if (els) {
      return els[this.tabIndex || 0];
    }
  }

  private hijackContentScroll() {
    let touchMoveData;

    const element = this.content._scrollContent.nativeElement,
      onMove = e => {
        const div = this.activeScrollDiv();
        this.debug('onMove', e, div);

        if (e._innerDivMove) {
          // Inner div already handled
          return;
        }

        // If no header height, content should NEVER move
        if (!this.heightData.headerHeight) {
          return this.cancelEvent(e);
        }

        // can't scroll top area if bottom is scrolled
        if (div && div.scrollTop) {
          this.debug(
            'trying to scroll container when body is scrolled',
            div.scrollTop
          );
          return this.cancelEvent(e);
        }

        if (!touchMoveData && _.size(e.touches)) {
          const { pageY, pageX } = e.touches && e.touches[0];
          touchMoveData = {
            startX: pageX,
            startY: pageY,
            lastX: pageX,
            lastY: pageY,
          };
          this.cancelEvent(e);
        } else if (touchMoveData && _.size(e.touches)) {
          const { pageY } = e.touches && e.touches[0],
            diffYFromLast = touchMoveData.lastY - pageY,
            { scrollTop, scrollLeft } = this.content.getContentDimensions(),
            next = Math.max(
              Math.min(scrollTop + diffYFromLast, this.heightData.headerHeight),
              0
            );

          this.cancelEvent(e);
          touchMoveData.lastY = pageY;
          this.content.scrollTo(
            scrollLeft,
            next,
            Math.abs(diffYFromLast) > 1 ? 10 : 0
          );
        }
      },
      onEnd = e => {
        this.debug('content on end');
        touchMoveData = null;
      };

    element.addEventListener('touchmove', onMove);
    element.addEventListener('touchend', onEnd);

    this.subs.push(() => {
      element.removeEventListener('touchmove', onMove);
      element.removeEventListener('touchend', onEnd);
    });
  }

  private unsubscribeEvents() {
    _.each(this.subs, s => {
      if (s instanceof Function) {
        s();
      } else if (s.unsubscribe) {
        s.unsubscribe();
      }
    });
  }

  ngOnDestroy() {
    this.unsubscribeEvents();
  }

  private slideBackRefresher() {
    if (
      this.touchMoveData &&
      this.touchMoveData.scrollParent &&
      !this.activeRefresher
    ) {
      this.touchMoveData.scrollParent.style.transition = `transform 0.2s`;
      this.touchMoveData.scrollParent.style.transform = `translateY(0px)`;
    }
  }

  touchEnd() {
    this.slideBackRefresher();
    this.touchMoveData = null;
  }

  touchMove(e, scrollParent) {
    const self = this;
    this.debug('div move', e, this.isSticky, scrollParent);

    e._innerDivMove = true;

    try {
      if (!this.touchMoveData && _.size(e.touches)) {
        const { pageY, pageX } = e.touches && e.touches[0];
        this.touchMoveData = {
          startX: pageX,
          startY: pageY,
          lastX: pageX,
          lastY: pageY,
          scrollParent: scrollParent,
          startScroll: scrollParent.scrollTop,
        };
        this.debug('touch move started', this.touchMoveData);
        if (!this.isSticky) {
          this.cancelEvent(e);
          this.touchMoveData.wasCancelled = true;
        }
      } else if (this.touchMoveData && _.size(e.touches)) {
        const { pageY } = e.touches && e.touches[0],
          diffYFromLast = this.touchMoveData.lastY - pageY;

        this.debug('touch moving', pageY, this.touchMoveData, diffYFromLast);
        this.touchMoveData.lastY = pageY;

        if (this.isSticky) {
          // If we are in sticky mode and the scroll content not at the top,
          // we want to just let the browser do it's thing.
          //
          // However, if we are already at the top, we want to instead
          // move the content

          if (scrollParent) {
            if (this.touchMoveData.inRefresher) {
              refresherScrolling(diffYFromLast);
            } else {
              const scrollY = scrollParent.scrollTop;
              if (!(scrollY <= 0 && diffYFromLast <= 0)) {
                if (this.touchMoveData.wasCancelled) {
                  return scrollDiv(diffYFromLast);
                } else {
                  return;
                }
              } else {
                // negative scrolling going on
                if (
                  !this.touchMoveData.startScroll &&
                  this.activeTabIsRefreshable()
                ) {
                  // can only start refresher if you were already at the top
                  refresherScrolling(diffYFromLast);
                } else {
                  return;
                }
              }
            }
          } else {
            // not sure what to do
            return;
          }
        }

        let { scrollTop, scrollLeft } = this.content.getContentDimensions();
        this.cancelEvent(e);
        this.touchMoveData.wasCancelled = true;
        this.debug(
          'will cancel! scrollTop(%s), diffYFromLast(%s)',
          scrollTop,
          diffYFromLast,
          scrollTop + diffYFromLast
        );
        this.content.scrollTo(
          scrollLeft,
          Math.max(
            Math.min(scrollTop + diffYFromLast, this.heightData.headerHeight),
            0
          ),
          Math.abs(diffYFromLast) > 1 ? 10 : 0
        );
      }
    } catch (e) {
      console.error(e);
    }

    function refresherScrolling(diffYFromLast) {
      if (self.activeRefresher) return;
      if (!self.touchMoveData.inRefresher) {
        self.touchMoveData.referesherPosition = 0;
      }
      self.touchMoveData.referesherPosition -= diffYFromLast;
      self.touchMoveData.refresherDirection = diffYFromLast < 0 ? 'up' : 'down';
      self.touchMoveData.referesherPosition = Math.min(
        self.touchMoveData.referesherPosition,
        self.refresherSettings.max
      );

      self.touchMoveData.inRefresher = true;

      self.debug('refresher', self.touchMoveData);
      scrollParent.style.transition = `none`;
      scrollParent.style.transform = `translateY(${self.touchMoveData.referesherPosition}px)`;

      if (
        self.touchMoveData.referesherPosition >=
        self.refresherSettings.threshold
      ) {
        self.debug('setting refresher', self.activeRefresher);
        const t = setTimeout(() => {
            self.activeRefresher && self.activeRefresher.complete();
          }, 5e3),
          parent = self.touchMoveData.scrollParent;
        self.activeRefresher = {
          complete: () => {
            self.debug('refresher done');
            self.activeRefresher = null;
            clearTimeout(t);
            parent.style.transition = `transform 0.2s`;
            parent.style.transform = `translateY(0px)`;
          },
        };
        self.refresh.emit({
          tab: self.tabs[self.tabIndex],
          tabIndex: self.tabIndex,
          refresher: self.activeRefresher,
        });
      }
    }

    function scrollDiv(diffYFromLast) {
      // if any event has been cancelled, we need to swith to manually scrolling
      const current = scrollParent.scrollTop,
        next = Math.max(
          Math.min(
            current + diffYFromLast,
            scrollParent.scrollHeight - scrollParent.clientHeight
          ),
          0
        );

      // self.log('scrolling manually from %s to %s', current, next);
      scrollParent.scrollTop = next;
    }
  }

  private cancelEvent(e) {
    this.debug('canceling event', e);
    try {
      e.preventDefault();
      e.stopImmediatePropagation();
    } catch (e) {}
  }

  private activeTabIsRefreshable() {
    return _.get(this.tabs, this.tabIndex + '.refreshable');
  }
}



// WEBPACK FOOTER //
// ./src/components/subnav-and-slides/subnav-and-slides.ts